import { createApi } from "@reduxjs/toolkit/query/react";
import { createCustomFetchBaseQuery } from "../baseQuery";

export const contractorAuthApi = createApi({
  reducerPath: "contractorAuth",
  baseQuery: createCustomFetchBaseQuery(),
  endpoints: (builder) => ({
   
    contractorLogin: builder.mutation({
      query: (login) => ({
        url: `/contractor/login`,
        method: "POST",
        body: login,
      }),
    }),

    contractorSignup: builder.mutation({
      query: (data) => ({
        url: `/contractor/signup`,
        method: "POST",
        body: data,
      }),
    }),

    register: builder.mutation({
      query: (register ) => ({
        url: `/auth/signup`,
        method: "POST",
        // headers: { "Content-Type": "multipart/form-data" },
        body: register,
      }),
    }),

    changePassword: builder.mutation({
      query: (data) => ({
        url: `/auth/resetPassword`,
        method: "PUT",
        body: data,
      }),
    }),

    verifyEmail: builder.mutation({
      query: (data) => ({
        url: `/auth/verify`,
        method: "POST",
        body: data,
      }),
    }),

    forgotPassword: builder.mutation({
      query: (data) => ({
        url: `/auth/forgotpassword`,
        method: "POST",
        body:data,
      }),
    }),
  })
});

export const {
 useForgotPasswordMutation,useContractorLoginMutation,useContractorSignupMutation,useRegisterMutation,useChangePasswordMutation,useVerifyEmailMutation,
} = contractorAuthApi;